module.exports = fox._r("fonts/simplifica.svg", __webpack_public_path__ + "fonts/simplifica.svg");


//////////////////
// WEBPACK FOOTER
// ./fonts/simplifica.svg
// module id = 47
// module chunks = 4